module.exports = __webpack_public_path__ + "static/louko-f1ffceec50a30389e7fdd0c2f61fbfbf.jpg";